export default "__VITE_ASSET__DogFLyF0__"